import { RootState } from '../../store/store';

/* Полноценный селектор для получения всего */
export const getRequestSinglePageSelector = ({
  requestSinglePage: state,
}: RootState) => state;

export const getPublicId = ({ requestSinglePage: state }: RootState) =>
  state.publicId;

export const getShowCallCardState = ({ requestSinglePage: state }: RootState) =>
  state.showCallCard;

export const getShowMetersResultModalState = ({
  requestSinglePage: state,
}: RootState) => state.showMetersResultModal;

export const getShowMetersReadingsModalState = ({
  requestSinglePage: state,
}: RootState) => state.showMetersReadingsModal;

export const getOnLoadPublicRequestState = ({
  requestSinglePage: state,
}: RootState) => state.onLoadRequestData;

export const getOnLoadPublicRequestAccrualsState = ({
  requestSinglePage: state,
}: RootState) => state.onLoadAccrualsData;

export const getOnLoadPublicRequestMetersState = ({
  requestSinglePage: state,
}: RootState) => state.onLoadMetersData;

export const getOnPostMetersReadingsState = ({
  requestSinglePage: state,
}: RootState) => state.onPostMetersReadingsStatus;

export const getAttachmentsStatus = ({ requestSinglePage: state }: RootState) =>
  state.attachmentsStatus;

export const getPublicRequestData = ({ requestSinglePage: state }: RootState) =>
  state.requestData;

export const selectMobileAppModalOpen = ({
  requestSinglePage: state,
}: RootState) => state.mobileAppModalOpen;

export const getAccrualsData = ({ requestSinglePage: state }: RootState) =>
  state.accrualsData;

export const getMetersData = ({ requestSinglePage: state }: RootState) =>
  state.metersData;

export const getMetersCheckRequestLink = ({
  requestSinglePage: state,
}: RootState) => state.metersCheckRequestLink;
